<mat-toolbar
    fxFill="1 1 100%"
    fxLayout.lt-sm="column"
    fxLayoutGap.gt-xs="0.5em"
    fxLayoutAlign="center center"
    color="warn"
    *ngIf="offline$ | async"
>
    <div fxLayoutGap="0.25em" fxLayoutAlign="center center" fxLayout="row">
        <mat-icon>error_outline</mat-icon>
        <span i18n>Connection lost. Check your internet connection.</span>
    </div>
</mat-toolbar>
